import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
//  Interface for Data table data type for all the columns
export interface Props {
  children?: FC;
  item?: AccountEventName;
}

interface AccountEventName {
  procedureName?: string;
}
const OrderProcedureCell: FC<Props> = ({
  item = {
    procedureName: '',
  },
}) => {
  const { procedureName } = item;
  return (
    <DataTableCell title={procedureName || ''}>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{procedureName}</p>
    </DataTableCell>
  );
};

/** Custom Account/Event Name cell */
export default OrderProcedureCell;
